module.exports = __webpack_public_path__ + "static/img/loading.af71cfd.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/loading.gif
// module id = 6
// module chunks = 4